export default {
  lista: [],
  estaCarregando: false,
  paginaAtual: 1,
  totalItens: null,
  todosItensCarregados: false,
  itemSelecionadoID: null,
  livroSelecionadoID: null,
  itemSelecionado: {
    id: null,
    planejamento_licao_id: null,
    descricao: null,
    numero: '',
    observacao: null,
    situacao: null
  }
}
